import React from 'react'

export default ({ title, onClick, marginTop, marginLeft }) =>
    <button
        className='medium-btn'
        style={{ marginTop, marginLeft, width: 100, fontSize: 14 }}
        onClick={onClick} >{title}</button>


// WEBPACK FOOTER //
// ./src/components/Regular/MediumBtn.js